import { useEffect, useState } from 'react';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import { RotateCcw, Loader2 } from 'lucide-react';

// Superadmin → Tenant → QR menyu: admin əl ilə sıraladığı kateqoriyalar (+ «Yeniliklər»).
// Sıfırlananda həm admin «Menyu idarəsi»ndə, həm QR menyuda superadmin «Məhsul sıralaması» işləyir.
export default function CustomSortReset({ tenantId }) {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState('');

    const load = () => {
        if (!tenantId) return;
        api.get(`/superadmin/tenants/${tenantId}/custom-sorted`)
            .then((r) => setData(r.data))
            .catch(() => setData({ categories: [], novelties: false }));
    };
    useEffect(load, [tenantId]); // eslint-disable-line react-hooks/exhaustive-deps

    const reset = async (target) => {
        setBusy(String(target));
        try {
            const r = await api.post(`/superadmin/tenants/${tenantId}/reset-item-order`, { target });
            toast.success(r.data?.msg || 'Sıfırlandı.');
            load();
        } catch (err) {
            toast.error(err.response?.data?.msg || 'Alınmadı.');
        } finally {
            setBusy('');
        }
    };

    if (!data) return null;
    const list = [
        ...(data.novelties ? [{ id: 'novelties', name: '✨ Yeniliklər' }] : []),
        ...(data.categories || []),
    ];

    return (
        <div className="rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-sm sm:col-span-2">
            <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-gray-700">Admin əl ilə sıraladığı kateqoriyalar</span>
                {list.length > 1 && (
                    <button type="button" disabled={!!busy} onClick={() => reset('all')}
                        className="flex items-center gap-1 rounded-lg border border-rose-200 bg-rose-50 px-2 py-1 text-xs font-semibold text-rose-700 hover:bg-rose-100 disabled:opacity-50">
                        {busy === 'all' ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />}
                        Hamısını sıfırla
                    </button>
                )}
            </div>
            {list.length === 0 ? (
                <p className="mt-1 text-xs text-gray-400">Yoxdur. Bütün kateqoriyalar yuxarıdakı sıralama ilə düzülür.</p>
            ) : (
                <div className="mt-2 flex flex-wrap gap-1.5">
                    {list.map((c) => (
                        <span key={c.id} className="flex items-center gap-1 rounded-full bg-emerald-50 py-0.5 pl-2.5 pr-1 text-xs font-semibold text-emerald-800 ring-1 ring-emerald-200">
                            {c.name}
                            <button type="button" disabled={!!busy} onClick={() => reset(c.id)} title="Sıfırla"
                                className="flex h-5 w-5 items-center justify-center rounded-full text-emerald-700 hover:bg-emerald-100 disabled:opacity-50">
                                {busy === String(c.id) ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />}
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <p className="mt-1.5 text-[11px] text-gray-400">Sıfırlananda həm admin menyusunda, həm QR-da yuxarıdakı sıralama işləyir.</p>
        </div>
    );
}
